export const environment = {
  production: false,
  environmentName: 'development' as const,
  neonAuthUrl: 'https://ep-raspy-fire-almmx4dd.neonauth.c-3.eu-central-1.aws.neon.tech/neondb/auth',
  gitSha: 'local',
  // Empty in dev — Sentry only active in staging/prod
  sentryDsn: '',
};
